import type { BarometerAuction } from '@autobid/ui/types/Car'
import type { AuctionsListAuction, Item, PreparedAuctionItem, PreparedBarometerAuction } from '@autobid/ui/types/components/AuctionsData'

interface ConvertItemDataToDisplayParams {
  data: AuctionsListAuction[]
  lang: string
}

interface ConvertBarometerAuctionDataToDisplayParams {
  data: BarometerAuction[]
  lang: string
}

function getSlug(slug: Record<string, string>, lang: string) {
  const langSlug = slug[lang.toUpperCase()]
  return langSlug || Object.values(slug ?? {})[0]
}

function prepareCommonAuctionData(
  item: Pick<Item, 'descriptions' | 'notice' | 'slug'>,
  lang: string,
) {
  return {
    title: item.descriptions.title?.[lang.toUpperCase()],
    descriptions: [
      item.descriptions.subtitleA?.[lang.toUpperCase()],
      item.descriptions.subtitleB?.[lang.toUpperCase()],
      item.descriptions.subtitleC?.[lang.toUpperCase()],
    ].filter(el => el !== undefined),
    notice: Object.values(item.notice ?? {})[0],
    allSlugs: item.slug,
    slug: getSlug(item.slug, lang),
  }
}

export function convertListOfAuctions({
  data,
  lang,
}: ConvertItemDataToDisplayParams): PreparedAuctionItem[] {
  return (data ?? []).map((item): PreparedAuctionItem => {
    return {
      ...item,
      ...prepareCommonAuctionData(item, lang),
      count: item.counters.publishedItems,
    }
  })
}

export function convertSingleAuction({
  data,
  lang,
}: ConvertBarometerAuctionDataToDisplayParams): PreparedBarometerAuction[] {
  return (data ?? []).map((item): PreparedBarometerAuction => {
    return {
      ...item,
      ...prepareCommonAuctionData(item, lang),
    }
  })
}
